import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_student-lodging-10/artifacts/ajwvtlfr_f8761343-7645-4d67-a513-d9697831aa50.jpeg";

export default function DashboardShell({ title, subtitle, children, testId = "dashboard-shell" }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    window.location.assign("/");
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA]" data-testid={testId}>
      <nav className="sticky top-0 z-40 bg-[#FFE600] border-b-2 border-[#0A0A0A]">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-3">
          <Link to="/" className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Vasavi Boys Hostel"
              className="h-10 w-auto border-2 border-[#0A0A0A] rounded-md bg-white object-contain"
            />
            <span className="hidden sm:block font-heading font-black text-lg leading-none">
              VASAVI
              <span className="block text-[10px] font-bold tracking-[0.3em] mt-1">BOYS HOSTEL</span>
            </span>
          </Link>
          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right">
              <div className="text-xs font-bold uppercase tracking-widest">{user?.role}</div>
              <div className="font-heading font-bold">{user?.name || user?.email}</div>
            </div>
            <button
              onClick={handleLogout}
              data-testid="logout-button"
              className="inline-flex items-center gap-2 font-bold text-sm px-4 py-2 border-2 border-[#0A0A0A] rounded-full bg-white hover:shadow-brutal-sm transition-shadow"
            >
              <LogOut size={16} /> Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="mb-8">
          {subtitle && (
            <span className="text-xs font-bold uppercase tracking-[0.2em]">{subtitle}</span>
          )}
          <h1 className="font-heading font-black text-4xl md:text-5xl tracking-tighter mt-1">
            {title}
          </h1>
        </div>
        {children}
      </div>
    </div>
  );
}
